var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('appbase',{ref:"appBase",attrs:{"beforePageTo":_vm.beforePageTo},on:{"route":_vm.route}},[(_vm.faqIMBtnEnable)?_c('faqimbtn',{attrs:{"slot":"footer"},slot:"footer"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }